
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface InterviewPrepProps {
	matchId: string | undefined;
}

export const InterviewPrep = ({ matchId }: InterviewPrepProps) => {
	const { t } = useTranslation();

	return (
		<div>
			<h3 className="text-lg font-semibold mb-4">{t("matches.interviewPrep.title", "Interview Preparation")}</h3>
			<Card>
				<CardContent className="p-6">
					<div className="text-center py-8">
						<p className="text-gray-500">
							{t("matches.interviewPrep.coming-soon", "Interview preparation tools coming soon!")}
						</p>
					</div>
				</CardContent>
			</Card>
		</div>
	);
};
